import React from 'react';

// Headless UI's scroll lock restyles <html> on open, and Chrome's scroll
// anchoring answers that by scrolling the page behind, a little more on each
// open. Layout effect so it lands before the browser lays out the lock.
export const useNoScrollAnchoring = (open: boolean) => {
  React.useLayoutEffect(() => {
    if (!open) {
      return;
    }
    const html = document.documentElement;
    const previous = html.style.overflowAnchor;
    html.style.overflowAnchor = 'none';
    return () => {
      html.style.overflowAnchor = previous;
    };
  }, [open]);
};
